
















  import {computed, defineComponent, ref} from "@vue/composition-api"

  const pickColor = (name: string, startingPositions: string[]): string => {
    const pos = startingPositions.findIndex(x => name === x)
    return ({
      0: 'red',
      1: 'yellow',
      2: 'green',
      3: 'blue',
      4: 'gray',
      5: 'orange',
      6: 'violet',
      7: 'silver'
    } as Record<number, string>)[pos]
  }

  function cStyle(height: number, margin: number, startingPositions: string[]) {
    return {
      leaderboardItem: {
        margin: `${margin}rem`,
        height: `${height}rem`,
      },
      leaderboardItemP: (name: string) => ({ backgroundColor: pickColor(name, startingPositions) })
    }
  }

  export default defineComponent({
    name: "Leaderboard",
    props: {
      stats: {
        required: true,
        type: Array as () => {name: string; score: number}[]
      },
      heightRem: {
        required: false,
        type: Number,
        default: 3
      } ,
      marginRem: {
        required: false,
        type: Number,
        default: 0.5
      },
      forceLandscape: {
        required: false,
        type: Boolean,
        default: false
      }
    },
    setup(props, { root }) {
      const items = ref<HTMLElement[]>()
      const startingPositions = props.stats.map(x => x.name)
      const windowOrientation = computed(
        () => props.forceLandscape ? 'landscape' : root.$store.state.windowOrientation)

      /*
      watch(() => props.stats, (newValue, oldValue) => {
        if (newValue !== oldValue) {
          props.stats.forEach((x, index) => {
            const newYPos = index * (props.heightRem + props.marginRem)
            const startingIndex = startingPositions.findIndex(y => x.name === y)
            const item = items.value![startingIndex]
            gsap.to(item, 1, {css: {y: newYPos}, ease: Power2.easeInOut})
          })
        }
      })
*/

      return {
        items,
        windowOrientation,
        ...cStyle(props.heightRem, props.marginRem, startingPositions)
      }
    }
  })
